import { FunctionComponent } from 'preact';

import { IconButton, IconButtonProps } from '../IconButton/IconButton';
import { useIcons } from '../../hooks/useIcons';

export const SettingsButton: FunctionComponent<IconButtonProps> = (props) => {
  const { Settings } = useIcons();

  return (
    <IconButton {...props}>
      <Settings />
    </IconButton>
  );
};
